import { Navigate, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, requireOnboarded = true, requireVerified = true }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navState = useMemo(() => ({ from: location }), [location]);

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-zinc-500 font-mono text-sm" data-testid="auth-loading">
        initializing_session…
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" state={navState} replace />;
  // Hard email-verification gate — unverified users cannot reach the
  // dashboard, labs, pricing or any protected route. The /verify-email
  // route itself opts out via `requireVerified={false}`.
  if (requireVerified && user.email_verified === false) {
    return <Navigate to="/verify-email" replace />;
  }
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}
